
      const target = document.getElementById("jspsych-target");
      const isFileProtocol = window.location.protocol === "file:";
      const isGitHubPages = window.location.hostname.endsWith(".github.io");
      const isBuilt = Boolean(import.meta.env?.PROD);

      if (isFileProtocol) {
        target.innerHTML = `
          <main style="font-family: system-ui, sans-serif; max-width: 720px; margin: 48px auto; padding: 0 24px; line-height: 1.5;">
            <h1 style="font-size: 24px;">Bitte ueber einen lokalen Server starten</h1>
            <p>Diese Vite-App kann nicht direkt als <code>file://</code> geoeffnet werden.</p>
            <p>Nutze lokal <code>npm run dev</code> oder <code>npm run preview</code> und oeffne dann die angezeigte <code>http://</code>-Adresse.</p>
          </main>
        `;
      } else if (isGitHubPages && !isBuilt) {
        window.location.replace(new URL("docs/", window.location.href));
      } else {
        import("/src/main.ts");
      }
    